import { nanoid } from "nanoid";
export const chatSettings = {
    guestCorePassID: nanoid(),
};
